import ComponentWithSocket from '../../../lib/component';
import { Component, Watch } from 'vue-property-decorator';
import moment from 'moment';
import 'moment/locale/ro';

import * as Store from '../../../store';
import * as Stock from '../../../utils/stock';
import { depositorName } from '../../../utils/depositor';

moment.locale('ro');

/**
 * Tinta codului QR de pe eticheta. Este ecranul folosit din depozit, de pe
 * telefon, deci actiunea principala trebuie sa fie la un singur tap.
 */
@Component
export default class StockLot extends ComponentWithSocket {
    public data: any = {
        lot: undefined,
        movements: [],
        // Cand exista mai multe loturi cu acelasi SKU, lasam utilizatorul sa
        // aleaga in loc sa ghicim noi.
        matches: [],
        note: '',
        error: '',
        loaded: false,
    };

    stockLabel = Stock.stockLabel;
    stockBadgeClass = Stock.stockBadgeClass;
    formatSku = Stock.formatSku;
    canSetInStock = Stock.canSetInStock;
    canSetOutOfStock = Stock.canSetOutOfStock;
    formatContractNumber = Stock.formatContractNumber;
    depositorName = depositorName;

    constructor() {
        super();

        this.wsListener.onGet('stock.lot', (success: boolean, data: any) => {
            Store.commitLoaderVisibility(this.$store, false);
            this.data.loaded = true;

            if (!success) {
                this.data.error = data;
                return;
            }

            this.data.error = '';

            if (data.matches) {
                this.data.matches = data.matches;
                this.data.lot = undefined;
                return;
            }

            this.data.matches = [];
            this.data.lot = data.lot;
            this.data.movements = data.movements;
        });

        this.wsListener.onPut('stock.lot', (success: boolean, data: any) => {
            Store.commitLoaderVisibility(this.$store, false);

            if (!success) {
                return alert(data);
            }

            this.data.lot = data.lot;
            this.data.movements = data.movements;
            this.data.note = '';
        });
    }

    mounted() {
        this.load();
    }

    @Watch('$route')
    onRouteChanged() {
        this.load();
    }

    beforeRouteLeave(to: any, from: any, next: any) {
        this._beforeLeave(to, from);
        next();
    }

    load() {
        Store.commitLoaderVisibility(this.$store, true);
        this.data.loaded = false;

        this.wsListener.sendGet('stock.lot', { sku: this.$route.params.sku });
    }

    get attributeList() {
        if (!this.data.lot || !this.data.lot.attributes) return [];

        return this.data.lot.attributes.filter(
            (attribute: any) => attribute.value,
        );
    }

    setStock(inStock: boolean) {
        Store.commitLoaderVisibility(this.$store, true);

        this.wsListener.sendPut('stock.lot', {
            _id: this.data.lot._id,
            inStock,
            note: this.data.note,
        });
    }

    openMatch(lot: any) {
        this.data.matches = [];
        this.data.lot = lot;
        this.wsListener.sendGet('stock.lot', { _id: lot._id });
    }

    printLabel() {
        this.$router.push(`/etichete?lots=${this.data.lot._id}`);
    }

    movementLabel(movement: any): string {
        return movement.event === 'in' ? 'Intrare in stoc' : 'Iesire din stoc';
    }

    formatDate(date: any): string {
        return date ? moment(date).format('DD.MM.YYYY HH:mm') : '';
    }

    userName(user: any): string {
        if (!user || !user._id) return '';
        return `${user.firstName || ''} ${user.lastName || ''}`.trim();
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/stock/lot/index.ts